import { createSlice } from "@reduxjs/toolkit";

const mySlice = createSlice({
  name: "Events",
  initialState: {
    isFetching: false,
    isCreating: false,
    isCreatingBooking: false,
    isUpdating: false,
    isConfirmingPayment: false,
    isgettingInvoice: false,
    isGetEvent: false,
    all: { data: [] },
    selected: null,
    selectedBooking: null,
    selectedInvoice: null,
    updated: null,
    new: null,
    completedPayment: null,
  },
  reducers: {
    setIsFetching(state, action) {
      state.isFetching = action.payload;
    },
    setIsGetEvent(state, action) {
      state.isGetEvent = action.payload;
    },
    setIsCreating(state, action) {
      state.isCreating = action.payload;
    },
    setSelected(state, action) {
      state.selected = action.payload;
    },
    setAll(state, action) {
      state.all = action.payload;
    },
    setNew(state, action) {
      state.new = action.payload;
    },
    setUpdated(state, action) {
      state.updated = action.payload;
    },
    setIsUpdating(state, action) {
      state.isUpdating = action.payload;
    },
    setIsCreatingBooking(state, action) {
      state.isCreatingBooking = action.payload;
    },
    setSelectedBooking(state, action) {
      state.selectedBooking = action.payload;
    },
    setIsConfirmingPayment(state, action) {
      state.isConfirmingPayment = action.payload;
    },
    setSelectedInvoice(state, action) {
      state.selectedInvoice = action.payload;
    },
    setIsgettingInvoice(state, action) {
      state.isgettingInvoice = action.payload;
    },
    setCompletedPayment(state, action) {
      state.completedPayment = action.payload;
    },
  },
});

export const myEventActions = mySlice.actions;

export default mySlice.reducer;
